/* JO MATTER V2 additions: colour names, header wishlist count, go-to-top on desktop, cart line edit popup. Loads after jm-global.js. */
(function () {
  if (!window.JM) { document.addEventListener('DOMContentLoaded', start); return; }
  start();
  function start() {
  var JM = window.JM;
  if (!JM || JM.v2) return;
  JM.v2 = true;
  var ROOT = JM.root || '/';
  var esc = JM.esc, money = JM.money, img = JM.img;

  /* ---------- colour names to swatch colours (same list as snippets/jm-color-hex.liquid) ---------- */
  var COLORS = [
    ['black', '#141414'], ['white', '#f7f7f5'], ['maroon', '#7a1f2b'], ['red', '#d32f2f'], ['olive', '#6b7a2f'], ['green', '#2e7d32'],
    ['brown|chocolate|coffee', '#6d4c41'], ['gray|grey', '#8c8c8c'], ['navy', '#1f2a44'], ['teal', '#00897b'], ['blue', '#1e5bd8'],
    ['yellow', '#f4c430'], ['orange', '#f57c00'], ['pink', '#e91e63'], ['purple|violet', '#7b1fa2'], ['beige|cream|ivory', '#e8dcc4'],
    ['khaki|sand', '#c3b091'], ['silver', '#c0c0c0'], ['gold', '#c9a227']
  ];
  JM.colorHex = function (name) {
    var n = String(name || '').toLowerCase();
    for (var i = 0; i < COLORS.length; i++) if (new RegExp(COLORS[i][0]).test(n)) return COLORS[i][1];
    return n.replace(/\s+/g, '');
  };
  /* pieces are Pitch Black with a coloured accent, so swatches are split diagonally */
  JM.swatchBg = function (name) {
    var hex = JM.colorHex(name);
    return 'linear-gradient(135deg,#141414 0 50%,' + hex + ' 50% 100%)';
  };
  function paintSwatches(scope) {
    (scope || document).querySelectorAll('.jm-qv__sw[data-val]').forEach(function (b) {
      if (b.dataset.jmPainted) return;
      b.dataset.jmPainted = '1';
      b.style.background = JM.swatchBg(b.dataset.val);
    });
  }

  /* ---------- wishlist count bubble in the header ---------- */
  var basePaint = JM.paint;
  JM.paint = function () {
    basePaint();
    var n = JM.wish.list().length;
    document.querySelectorAll('.jm-hwish__n').forEach(function (e) { e.textContent = n > 99 ? '99+' : n; e.hidden = n === 0; });
    paintSwatches();
  };

  /* ---------- go-to-top: on desktop Horizon scrolls .page-wrapper, not the window ---------- */
  function scroller() {
    var pw = document.querySelector('.page-wrapper');
    if (pw && pw.scrollHeight > pw.clientHeight + 2 && /(auto|scroll)/.test(getComputedStyle(pw).overflowY)) return pw;
    return null;
  }
  var C = 2 * Math.PI * 26, ticking = false;
  function topUpdate() {
    ticking = false;
    var btn = document.querySelector('[data-jm-top]');
    if (!btn) return;
    var bar = btn.querySelector('.jm-top__bar');
    if (!bar) return;
    var s = scroller(), y, max;
    if (s) { y = s.scrollTop; max = s.scrollHeight - s.clientHeight; }
    else { var d = document.scrollingElement || document.documentElement; y = window.scrollY || d.scrollTop; max = d.scrollHeight - window.innerHeight; }
    var p = max > 0 ? Math.min(1, Math.max(0, y / max)) : 0;
    bar.style.strokeDasharray = C;
    bar.style.strokeDashoffset = C * (1 - p);
    btn.classList.toggle('is-scrolled', y > 200);
  }
  function topQueue() { if (!ticking) { ticking = true; requestAnimationFrame(topUpdate); } }
  document.addEventListener('scroll', topQueue, { capture: true, passive: true });
  window.addEventListener('resize', topQueue);
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-jm-top]')) return;
    var s = scroller();
    if (s) s.scrollTo({ top: 0, behavior: 'smooth' });
  });

  /* ---------- cart drawer: pen button + Edit Option popup ---------- */
  var PEN = '<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 20h4L19 9a2.8 2.8 0 00-4-4L4 16v4z"/><path d="M13.5 6.5l4 4"/></svg>';
  var Drawer = customElements.get('jm-cart-drawer');
  if (Drawer) {
    var baseLine = Drawer.prototype.lineHTML;
    var baseAct = Drawer.prototype.act;
    Drawer.prototype.lineHTML = function (it) {
      var h = baseLine.call(this, it);
      if (it.product_has_only_default_variant && !packs().length) return h;
      return h.replace('<button type="button" class="jm-cd__del"', '<button type="button" class="jm-cd__edit" data-act="edit" aria-label="Edit ' + esc(it.product_title) + '">' + PEN + '</button><button type="button" class="jm-cd__del"');
    };
    Drawer.prototype.fillColor = function () {};
    Drawer.prototype.act = function (btn) {
      if (btn.dataset.act === 'edit') {
        var line = btn.closest('[data-key]');
        var it = this.cart && this.cart.items.find(function (x) { return x.key === line.dataset.key; });
        if (it) JM.editLine(it);
        return;
      }
      return baseAct.call(this, btn);
    };
    if (JM.drawer && JM.drawer.cart) JM.drawer.render(JM.drawer.cart);
  }

  function packs() {
    var d = document.getElementById('cart-drawer');
    return String((d && d.dataset.packs) || '1,3,5').split(',').map(function (x) { return parseInt(x, 10); }).filter(function (x) { return x > 0; });
  }

  var modal;
  function getModal() {
    if (modal) return modal;
    modal = document.createElement('div');
    modal.className = 'jm-em';
    modal.innerHTML = '<div class="jm-em__back" data-em-close></div><div class="jm-em__box" role="dialog" aria-modal="true" aria-labelledby="jm-em-h"><div class="jm-em__head"><h3 id="jm-em-h">Edit Option</h3><button type="button" class="jm-em__x" data-em-close aria-label="Close">' + JM.icons.close + '</button></div><div class="jm-em__in" data-em-in></div></div>';
    document.body.appendChild(modal);
    modal.addEventListener('click', function (e) { if (e.target.closest('[data-em-close]')) JM.closeEdit(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modal.classList.contains('is-open')) { e.stopPropagation(); JM.closeEdit(); } }, true);
    return modal;
  }
  JM.closeEdit = function () {
    if (!modal) return;
    modal.classList.remove('is-open');
    if (modal._back && modal._back.focus) modal._back.focus();
  };

  JM.editLine = function (it) {
    var m = getModal(), box = m.querySelector('[data-em-in]');
    m._back = document.activeElement;
    box.innerHTML = '<p class="jm-em__load">Loading...</p>';
    m.classList.add('is-open');
    JM.product(it.handle).then(function (p) { renderEdit(box, p, it); }).catch(function () { box.innerHTML = '<p class="jm-em__load">Could not load this product.</p>'; });
  };

  function renderEdit(box, p, it) {
    var names = (p.options || []).map(function (o) { return String(o && o.name ? o.name : o); });
    var single = p.variants.length === 1 && /default title/i.test(p.variants[0].title);
    var cur = p.variants.find(function (v) { return v.id === it.variant_id; }) || p.variants[0];
    var sel = cur.options.slice(), qty = it.quantity, pk = packs();
    var h = '<div class="jm-em__prod"><span class="jm-em__img"><img data-em-img src="' + img((cur.featured_image && cur.featured_image.src) || p.featured_image || it.image, 240) + '" alt="' + esc(p.title) + '"></span><div><p class="jm-em__title">' + esc(p.title) + '</p><p class="jm-em__price"><b data-em-price></b><s data-em-was></s></p></div></div>';
    if (!single) names.forEach(function (n, i) {
      var isC = /^colou?r$/i.test(n), vals = [];
      p.variants.forEach(function (v) { if (vals.indexOf(v.options[i]) < 0) vals.push(v.options[i]); });
      h += '<div class="jm-em__opt"><p>' + esc(n) + ': <b data-em-lab="' + i + '"></b></p><div class="jm-em__vals">' + vals.map(function (val) {
        return '<button type="button" class="' + (isC ? 'jm-em__sw' : 'jm-em__pill') + '" data-em-opt="' + i + '" data-val="' + esc(val) + '"' + (isC ? ' style="background:' + esc(JM.swatchBg(val)) + '" title="' + esc(val) + '" aria-label="' + esc(val) + '"' : '') + '>' + (isC ? '' : esc(val)) + '</button>';
      }).join('') + '</div></div>';
    });
    if (pk.length > 1) h += '<div class="jm-em__opt"><p>Quantity: <b data-em-qlab></b></p><div class="jm-em__vals">' + pk.map(function (n) { return '<button type="button" class="jm-em__pill" data-em-pack="' + n + '">Buy ' + n + '</button>'; }).join('') + '</div></div>';
    h += '<div class="jm-em__buy"><div class="jm-qty"><button type="button" data-em-q="-1" aria-label="Decrease quantity">&minus;</button><input type="number" min="1" value="' + qty + '" data-em-qty aria-label="Quantity"><button type="button" data-em-q="1" aria-label="Increase quantity">+</button></div><button type="button" class="jm-atc" data-em-save>Update Cart</button></div>';
    box.innerHTML = h;

    function find() { return p.variants.find(function (v) { return v.options.every(function (x, i) { return x === sel[i]; }); }); }
    function upd() {
      var v = find();
      box.querySelectorAll('[data-em-opt]').forEach(function (b) {
        var i = +b.dataset.emOpt, on = sel[i] === b.dataset.val;
        b.classList.toggle('is-on', on);
        var test = sel.slice(); test[i] = b.dataset.val;
        var tv = p.variants.find(function (x) { return x.options.every(function (y, k) { return y === test[k]; }); });
        b.classList.toggle('is-off', !(tv && tv.available));
      });
      box.querySelectorAll('[data-em-lab]').forEach(function (l) { l.textContent = sel[+l.dataset.emLab]; });
      box.querySelectorAll('[data-em-pack]').forEach(function (b) { b.classList.toggle('is-on', +b.dataset.emPack === qty); });
      var ql = box.querySelector('[data-em-qlab]'); if (ql) ql.textContent = pk.indexOf(qty) > -1 ? 'Buy ' + qty : qty;
      box.querySelector('[data-em-qty]').value = qty;
      var save = box.querySelector('[data-em-save]');
      if (!v) { save.disabled = true; save.textContent = 'Unavailable'; return; }
      box.querySelector('[data-em-price]').textContent = money(v.price * qty);
      box.querySelector('[data-em-was]').textContent = v.compare_at_price > v.price ? money(v.compare_at_price * qty) : '';
      save.disabled = !v.available;
      save.textContent = v.available ? 'Update Cart' : 'Sold out';
      var im = box.querySelector('[data-em-img]');
      if (im && v.featured_image && v.featured_image.src) im.src = img(v.featured_image.src, 240);
    }
    box.onclick = function (e) {
      var o = e.target.closest('[data-em-opt]'); if (o) { sel[+o.dataset.emOpt] = o.dataset.val; upd(); return; }
      var k = e.target.closest('[data-em-pack]'); if (k) { qty = +k.dataset.emPack; upd(); return; }
      var q = e.target.closest('[data-em-q]'); if (q) { qty = Math.max(1, qty + (+q.dataset.emQ)); upd(); return; }
      var s = e.target.closest('[data-em-save]');
      if (s && !s.disabled) {
        var v = find(); if (!v) return;
        s.disabled = true; s.textContent = 'Updating...';
        /* Shopify can change line keys after any cart change, so find the old line again in a fresh cart before touching it. */
        function oldKey() {
          return JM.getCart().then(function (c) {
            var same = c.items.filter(function (x) { return x.variant_id === it.variant_id; });
            var hit = same.find(function (x) { return x.key === it.key; }) || same.find(function (x) { return x.quantity === it.quantity; }) || same[0];
            if (!hit) throw new Error('This item is no longer in your cart.');
            return hit.key;
          });
        }
        var job = v.id === it.variant_id
          ? oldKey().then(function (k) { return JM.change(k, qty); })
          : fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: v.id, quantity: qty }] }) })
            .then(function (r) { return r.json().then(function (d) { if (!r.ok || d.status) throw new Error(d.description || d.message || 'Could not update the cart.'); }); })
            .then(oldKey)
            .then(function (k) { return JM.change(k, 0); });
        job.then(function () { JM.closeEdit(); JM.toast('Cart updated'); })
          .catch(function (err) { s.disabled = false; s.textContent = 'Update Cart'; JM.toast(err.message); if (JM.drawer) JM.drawer.refresh(); });
      }
    };
    box.querySelector('[data-em-qty]').addEventListener('change', function (e) { qty = Math.max(1, parseInt(e.target.value, 10) || 1); upd(); });
    upd();
    var x = modal.querySelector('.jm-em__x'); if (x) x.focus();
  }

  function init() { JM.paint(); topUpdate(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('load', topUpdate);
  }
})();
